import { FC } from 'react';
import { trackProfessionalSearchClick } from './tracking';
import { useSelector } from 'react-redux';
import { selectSearchMetaRefreshing, selectSearchResultsText } from 'shared/selectors/searchMeta';
import { AdvancedFiltersModalFooter } from 'shared/components/AdvancedFiltersModalFooter';
import { selectIsProfessionalSearchSearchAvailable } from 'shared/selectors/professionalSearch';

interface IAdvancedFiltersModalFooterContainerProps {
  onFiltersReset: VoidFunction;
  onFiltersApply: VoidFunction;
}

export const AdvancedFiltersModalFooterContainer: FC<IAdvancedFiltersModalFooterContainerProps> = ({
  onFiltersReset,
  onFiltersApply,
}) => {
  const isSearchMetaRefreshing = useSelector(selectSearchMetaRefreshing);
  const searchButtonText = useSelector(selectSearchResultsText);
  const isProfessionalSearchAvailable = useSelector(selectIsProfessionalSearchSearchAvailable);

  return (
    <AdvancedFiltersModalFooter
      searchButtonText={searchButtonText}
      isCounterRefreshing={isSearchMetaRefreshing}
      onClearClick={onFiltersReset}
      onShowClick={onFiltersApply}
      isProfessionalSearchButtonVisible={isProfessionalSearchAvailable}
      onProfessionalSearchClick={trackProfessionalSearchClick}
    />
  );
};
